import "angular";
import "@uirouter/angularjs";
import firebase from "firebase/app";
import "firebase/functions";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "angularfire";
import "rx-angular";

import "../tmp/templates";

import "./layout";
import "./form-builder";
import "./dynamic-builder";
import "./form-render";
import "./user";
import "./services/flash-service";
import "./providers";
import "./schema";
import FormEngineService from "./services/form-engine.service";
import RecordService from "./services/record.service";
import ReportGroupService from "./services/report-group.service";
import DomService from "./services/dom.service";
import EventService from "./services/event.service";
import TemplateService from "./services/template.service";
import RouteResolverService from "./services/route-resolver.service";
import QueryParamService from "./services/query-param.service";
import StorageService from "./services/storage.service";

import ENV from "../environments/environment";

const DEPENDENCIES = [
  'ui.router',
  'templates',
  'app.layout',
  'app.form-builder',
  'app.dynamic-builder',
  'ais.form-render',
  'ais.user',
  'ais.flash-service',
  'firebase',
  'schema',
  'providers',
  'rx'
];

angular
  .module('app', DEPENDENCIES)
  .config(['$stateProvider', '$urlRouterProvider', 'ENVIRONMENT', function($stateProvider, $urlRouterProvider, ENVIRONMENT) {
    $stateProvider
      .state('app', {
        abstract: true,
        templateUrl: 'layout/app-layout/app-layout.html',
      })
      .state('app.connections', {
        url: '/connections',
        template: '<connections></connections>',
        data: { title: 'User Connections - Form Engine' },
        resolve: {
          authenticate: ['AuthService', (AuthService) => AuthService.user()]
        }
      })
      .state('app.profile', {
        url: '/profile',
        template: '<profile></profile>',
        data: { title: 'Update Profile - Form Engine' },
        resolve: {
          authenticate: ['AuthService', (AuthService) => AuthService.user()]
        }
      })
      .state('render-template', {
        url: '/render-template?:templateId&:action&:rids&:prefill&:connection&:redirect&:keepWorking&:download&:providerSignedAccess&:serverSignedAccess&:submitLinkId',
        template: '<render-template></render-template>',
        params: {
          previousAction: null,
          successType: null,
          redirect: null,
          keepWorking: null,
          download: null,
          providerSignedAccess: null,
          serverSignedAccess: null,
          submitLinkId: null
        },
        data: {
          title: 'Form Engine',
        }
      })

      .state('render-dynamic', {
        url: '/render-dynamic?:templateId&:action&:rids&:prefill&:connection&:redirect&:keepWorking&:download&:providerSignedAccess&:serverSignedAccess&:submitLinkId',
        template: '<render-dynamic></render-dynamic>',
        params: {
          previousAction: null,
          successType: null,
          redirect: null,
          keepWorking: null,
          download: null,
          providerSignedAccess: null,
          serverSignedAccess: null,
          submitLinkId: null
        },
        data: {
          title: 'Form Engine',
        }
      })

      .state('registration', {
        url: '/register',
        template: '<auth></auth>',
        data: { title: 'Login - Form Engine' }
      })
      .state('login', {
        url: '/login/:provider',
        template: '<auth></auth>',
        data: { title: 'Login - Form Engine' },
        params: { provider: {squash: true, value: null}, validationErrorMessage: {squash: true, value: null} }
      })
      .state('auth-with-connection', {
        url: '/auth-with-connection?:code&:authRedirect',
        template: '<auth-with-connection></auth-with-connection>',
        data: { title: 'Login - Form Engine' }
      })
      
      .state('terms', {
        url: '/terms',
        template: 'Redirecting to Terms of Service article...',
        onEnter: ['$window', function($window) {
          $window.open('https://formengine.freshdesk.com/support/solutions/articles/70000411515-terms-of-service', '_self');
        }]
      });

    const app = firebase.initializeApp(ENVIRONMENT.firebase); 
    const { hostname } = window.location;
    if (hostname === "localhost" || hostname === "127.0.0.1") {      
      app.functions().useFunctionsEmulator(`http://localhost:${ENV.firebase.localPort}`); 
    }
    $urlRouterProvider.otherwise('/');
  }])
  .constant('ENVIRONMENT', ENV)
  .constant('firebase', firebase)
  .constant('featureAccess', function(realm){
    const accessMap = {
      // basf: ['embedded-reports'],
    };
    return accessMap[realm] || [];
  })
  .service('FEService', FormEngineService)
  .service('RecordService', RecordService)
  .service('DomService', DomService)
  .service('EventService', EventService)
  .service('ReportGroupService', ReportGroupService)
  .service('TemplateService', TemplateService)
  .service('RouteResolverService', RouteResolverService)
  .service('QueryParamService', QueryParamService)
  .service('StorageService', StorageService)
  .run(['$rootScope', '$state',
    async ($rootScope, $state) => {
      $rootScope.$state = $state;
    }
  ])
  .config(["$provide", function($provide) {
    var inputDecoration = ["$delegate", "inputsWatcher", function($delegate, inputsWatcher) {
      var directive = $delegate[0];
      var link = directive.link;
      
      function linkDecoration(scope, element, attrs, ngModels){
        var handler;
        const ngModel = ngModels[0];
        if( ngModel){
          // By default model.$viewValue is equals to undefined
          if(attrs.type == "checkbox"){
            inputsWatcher.registerInput(handler = function(){
              var value = element[0].checked;
              // By default element is not checked
              if (value && ngModel.$viewValue !== value) {
                ngModel.$setViewValue(value);
              }
            });
          }else if(attrs.type == "radio"){
            inputsWatcher.registerInput(handler = function(){
              var value = attrs.value;
              // By default element is not checked
              if (element[0].checked && ngModel.$viewValue !== value) {
                ngModel.$setViewValue(value);
              }
            });
          }else{
            inputsWatcher.registerInput(handler = function(){
              var value = element.val();
              // By default value is an empty string
              if ((ngModel.$viewValue !== undefined || value !== "") && ngModel.$viewValue !== value) {
                ngModel.$setViewValue(value);
              }
            });
          }
        }
        
        scope.$on("$destroy", function(){
          inputsWatcher.unregisterInput(handler);
        });
        
        // Exec original `link()`
        link.pre.apply(this, [].slice.call(arguments, 0));
      }
      
      // Decorate `link()` don't work for `inputDirective` (why?)
      /*
      directive.link = linkDecoration;
      */
      // So use `compile()` instead
      directive.compile = function compile(element, attrs, transclude){
        return linkDecoration;
      };
      delete directive.link;
      
      return $delegate;
    }];

    $provide.decorator("inputDirective", inputDecoration);
    $provide.decorator("textareaDirective", inputDecoration);
    //TODO decorate selectDirective (see binding "change" for `Single()` and `Multiple()`)
  }])
  .factory("inputsWatcher", ["$interval", "$rootScope", function($interval, $rootScope){
    var INTERVAL_MS = 500;
    var promise;
    var handlers = [];

    function execHandlers(){
      for(var i = 0, l = handlers.length; i < l; i++){
        handlers[i]();
      }
    }
    
    return {
      registerInput: function registerInput(handler){
        if(handlers.push(handler) == 1){
          promise = $interval(execHandlers, INTERVAL_MS);
        }
      },
      unregisterInput: function unregisterInput(handler){
        handlers.splice(handlers.indexOf(handler), 1);
        if(handlers.length == 0){
          $interval.cancel(promise);
        }
      }
    };
}]);

angular.bootstrap(document, ['app']);
